import React from 'react';
import { CognitoUser } from '../types';
import ContentEditor from './ContentEditor';
import { AWSCredentials } from '../services/cognitoService';
import styles from './EditorPanel.module.css';

interface EditorPanelProps {
  user: CognitoUser;
  credentials: AWSCredentials;
  onLogout: () => void;
}

export default function EditorPanel({
  user,
  credentials,
  onLogout,
}: EditorPanelProps) {
  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1 className={styles.title}>Content Editor</h1>
        <div className={styles.userInfo}>
          <span className={styles.username}>Username: {user.username}</span>
          <button onClick={onLogout} className={styles.logoutButton}>
            Logout
          </button>
        </div>
      </header>
      <main className={styles.main}>
        <ContentEditor credentials={credentials} />
      </main>
    </div>
  );
}
